import { __awaiter, __generator } from "tslib";
import { dbStoreName } from '../models/Constants';
export function getTopCachedData(database) {
    return __awaiter(this, void 0, void 0, function () {
        var result, db, currentDateInMilliseconds, keyRange;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = undefined;
                    if (!('Proxy' in window)) return [3 /*break*/, 3];
                    return [4 /*yield*/, database];
                case 1:
                    db = _a.sent();
                    currentDateInMilliseconds = new Date().getTime();
                    keyRange = IDBKeyRange.lowerBound(-currentDateInMilliseconds);
                    return [4 /*yield*/, db
                            .transaction(dbStoreName, 'readonly')
                            .store.index('useractions_date_desc')
                            .getAll(keyRange, 15)];
                case 2:
                    // Read the first 15 items from IndexedDB
                    result = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, result];
            }
        });
    });
}
//# sourceMappingURL=getTopCachedData.js.map